<template>
    <v-layout row>
        <v-flex xs12 sm12>
            <v-card class="elavation-1 transparent">
                <v-toolbar class="transparent" flat height="37">
                    <v-btn dark icon title="Back previous page" @click="$router.go(-1)">
                        <v-icon>arrow_back</v-icon>
                    </v-btn>
                    <v-spacer></v-spacer>
                    <help-link appId="payroll" pageId="reference-tables" color="white"></help-link>
                </v-toolbar>
            </v-card>

            <v-progress-linear v-if="loading" indeterminate height="3" class="mt-0"></v-progress-linear>

            <v-expansion-panel v-if="!loading" v-model="panel" expand class="mt-5">
                <!-- Income Tax Table -->
                <v-expansion-panel-content>
                    <template v-slot:header>
                        <span class="font-weight-bold primary--text">Income Tax Table</span>
                        <v-spacer></v-spacer>
                    </template>
                    <v-card class="elavation-1 transparent">
                        <v-data-table
                            :headers="isMobile ? [] : header_IcomeTaxTable"
                            :items="ref_tables.incomeTaxTable"
                            :loading="loading"
                            :rows-per-page-items="rowsPerPageItems"
                            :pagination.sync="paginationSyncTax"
                            :hide-headers="isMobile"
                        >
                            <template v-slot:items="props">

                                <!-- mobile view -->
                                <tr v-if="isMobile">
                                    <td :colspan="header_IcomeTaxTable.length" class="pa-1">
                                        <v-card class="elevation-1">
                                            <v-toolbar flat height="42">
                                                <b>{{ props.item.type }}</b>
                                                <v-spacer></v-spacer>
                                            </v-toolbar>
                                            <v-layout row wrap align-center class="section-layout">
                                                <v-flex xs12 class="text-xs-left mt-5 mb-2">
                                                    <v-layout row>
                                                        <v-flex xs4>
                                                            <div class="caption grey--text text--darken-1">Effective Date</div>
                                                            <div>{{ props.item.effectiveDate | moment('MMM DD, YYYY')}}</div>
                                                        </v-flex>
                                                        <v-flex xs4>
                                                            <div class="caption grey--text text--darken-1">Lower Limit</div>
                                                            <div>{{numFormat.formatNumber(props.item.lowerLimit)}}</div>
                                                        </v-flex>
                                                        <v-flex xs4>
                                                            <div class="caption grey--text text--darken-1">Upper Limit</div>
                                                            <div v-if="props.item.upperLimit==-1">Over {{ numFormat.formatNumber(props.item.lowerLimit) }}</div>
                                                            <div v-else>{{ numFormat.formatNumber(props.item.upperLimit) }}</div>
                                                        </v-flex>
                                                    </v-layout>
                                                    <v-layout row>
                                                        <v-flex xs4>
                                                            <div class="caption grey--text text--darken-1">Tax on Lower Limit</div>
                                                            <div>{{numFormat.formatNumber(props.item.taxOnLowerLimit)}}</div>
                                                        </v-flex>
                                                        <v-flex xs8>
                                                            <div class="caption grey--text text--darken-1">Tax on Excess over Lower Limit</div>
                                                            <div>{{numFormat.formatNumber(props.item.taxOnExcessOverLowerLimit * 100) }} %</div>
                                                        </v-flex>
                                                    </v-layout>
                                                </v-flex>
                                            </v-layout>
                                        </v-card>
                                    </td>
                                </tr>

                                <!-- desktop view -->
                                <tr v-else>
                                    <td>{{ props.item.type }}</td>
                                    <td>{{ props.item.effectiveDate | moment('MMM DD, YYYY')}}</td>
                                    <td>
                                        <div class="text-xs-right">
                                            {{numFormat.formatNumber(props.item.lowerLimit)}}
                                        </div>
                                    </td>
                                    <td>
                                        <div class="text-xs-right">
                                            <span v-if="props.item.upperLimit==-1">Over {{ numFormat.formatNumber(props.item.lowerLimit) }}</span>
                                            <span v-else>{{ numFormat.formatNumber(props.item.upperLimit) }}</span>
                                        </div>
                                    </td>
                                    <td>
                                        <div class="text-xs-right">
                                            {{numFormat.formatNumber(props.item.taxOnLowerLimit)}}
                                        </div>
                                    </td>
                                    <td>
                                        <div class="text-xs-right">
                                            {{numFormat.formatNumber(props.item.taxOnExcessOverLowerLimit * 100) }} %
                                        </div>
                                    </td>
                                </tr>
                            </template>
                        </v-data-table> 
                    </v-card>
                </v-expansion-panel-content>

                <!-- SSS Table -->
                <v-expansion-panel-content>
                    <template v-slot:header>
                        <span class="font-weight-bold primary--text">SSS Table</span>
                        <v-spacer></v-spacer>
                    </template>
                    <v-card class="elavation-1 transparent">
                        <v-data-table
                            :headers="isMobile ? [] : header_SSS"
                            :items="ref_tables.sssTable"
                            :loading="loading"
                            :rows-per-page-items="rowsPerPageItems"
                            :pagination.sync="paginationSyncSSS"
                            :hide-headers="isMobile"
                        >
                            <template v-slot:items="props">

                                <!-- mobile view -->
                                <tr v-if="isMobile">
                                    <td :colspan="header_SSS.length" class="pa-1">
                                        <v-card class="elevation-1">
                                            <v-layout row wrap align-center class="section-layout">
                                                <v-flex xs12 class="text-xs-left mt-5 mb-2">
                                                    <v-layout row>
                                                        <v-flex xs4>
                                                            <div class="caption grey--text text--darken-1">Effective Date</div>
                                                            <div>{{ props.item.effectiveDate | moment('MMM DD, YYYY')}}</div>
                                                        </v-flex>
                                                        <v-flex xs4>
                                                            <div class="caption grey--text text--darken-1">Salary From</div>
                                                            <div>{{numFormat.formatNumber(props.item.salaryStart)}}</div>
                                                        </v-flex>
                                                        <v-flex xs4>
                                                            <div class="caption grey--text text--darken-1">Salary To</div>
                                                            <div>{{numFormat.formatNumber(props.item.salaryEnd)}}</div>
                                                        </v-flex>
                                                    </v-layout>
                                                    <v-layout row>
                                                        <v-flex xs4>
                                                            <div class="caption grey--text text--darken-1">RSS_ER</div>
                                                            <div>{{numFormat.formatNumber(props.item.rsS_ER)}}</div>
                                                        </v-flex>
                                                        <v-flex xs4>
                                                            <div class="caption grey--text text--darken-1">RSS_EE</div>
                                                            <div>{{numFormat.formatNumber(props.item.rsS_EE)}}</div>
                                                        </v-flex>
                                                        <v-flex xs4>
                                                            <div class="caption grey--text text--darken-1">EC_ER</div>
                                                            <div>{{numFormat.formatNumber(props.item.eC_ER)}}</div>
                                                        </v-flex>
                                                    </v-layout>
                                                    <v-layout row>
                                                        <v-flex xs4>
                                                            <div class="caption grey--text text--darken-1">EC_EE</div>
                                                            <div>{{numFormat.formatNumber(props.item.eC_EE)}}</div>
                                                        </v-flex>
                                                        <v-flex xs4>
                                                            <div class="caption grey--text text--darken-1">WISP_ER</div>
                                                            <div>{{numFormat.formatNumber(props.item.mpF_ER)}}</div>
                                                        </v-flex>
                                                        <v-flex xs4>
                                                            <div class="caption grey--text text--darken-1">WISP_EE</div>
                                                            <div>{{numFormat.formatNumber(props.item.mpF_EE)}}</div>
                                                        </v-flex>
                                                    </v-layout>
                                                </v-flex>
                                            </v-layout>
                                        </v-card>
                                    </td>
                                </tr>

                                <!-- desktop view -->
                                <tr v-else>
                                    <td>{{ props.item.effectiveDate | moment('MMM DD, YYYY')}}</td>
                                    <td>
                                        <div class="text-xs-right">
                                            {{numFormat.formatNumber(props.item.salaryStart)}}
                                        </div>
                                    </td>
                                    <td>
                                        <div class="text-xs-right">
                                            {{numFormat.formatNumber(props.item.salaryEnd)}}
                                        </div>
                                    </td>
                                    <td>
                                        <div class="text-xs-right">
                                            {{numFormat.formatNumber(props.item.rsS_ER)}}
                                        </div>
                                    </td>
                                    <td>
                                        <div class="text-xs-right">
                                            {{numFormat.formatNumber(props.item.rsS_EE)}}
                                        </div>
                                    </td>
                                    <td>
                                        <div class="text-xs-right">
                                            {{numFormat.formatNumber(props.item.eC_ER)}}
                                        </div>
                                    </td>
                                    <td>
                                        <div class="text-xs-right">
                                            {{numFormat.formatNumber(props.item.eC_EE)}}
                                        </div>
                                    </td>
                                    <td>
                                        <div class="text-xs-right">
                                            {{numFormat.formatNumber(props.item.mpF_ER)}}
                                        </div>
                                    </td>
                                    <td>
                                        <div class="text-xs-right">
                                            {{numFormat.formatNumber(props.item.mpF_EE)}}
                                        </div>
                                    </td>
                                </tr>
                            </template>
                        </v-data-table> 
                    </v-card>
                </v-expansion-panel-content>

                <!-- Pagibig Table -->
                <v-expansion-panel-content>
                    <template v-slot:header>
                        <span class="font-weight-bold primary--text">Pagibig Table</span>
                        <v-spacer></v-spacer>
                    </template>
                    <v-card class="elavation-1 transparent">
                        <v-data-table
                            :headers="isMobile? [] : header_Pagibig"
                            :items="ref_tables.pagibigTable"
                            :loading="loading"
                            :rows-per-page-items="rowsPerPageItems"
                            :pagination.sync="paginationSyncPagibig"
                            :hide-headers="isMobile"
                        >
                            <template v-slot:items="props">

                                <!-- mobile view -->
                                <tr v-if="isMobile">
                                    <td :colspan="header_Pagibig.length" class="pa-1">
                                        <v-card class="elevation-1">
                                            <v-layout row wrap align-center class="section-layout">
                                                <v-flex xs12 class="text-xs-left mt-5 mb-2">
                                                    <v-layout row>
                                                        <v-flex xs4>
                                                            <div class="caption grey--text text--darken-1">Effective Date</div>
                                                            <div>{{ props.item.effectiveDate | moment('MMM DD, YYYY')}}</div>
                                                        </v-flex>
                                                        <v-flex xs4>
                                                            <div class="caption grey--text text--darken-1">Salary From</div>
                                                            <div>{{numFormat.formatNumber(props.item.salaryStart)}}</div>
                                                        </v-flex>
                                                        <v-flex xs4>
                                                            <div class="caption grey--text text--darken-1">Salary To</div>
                                                            <div v-if="props.item.salaryEnd>1500">
                                                                Above {{numFormat.formatNumber(props.item.salaryStart)}}
                                                            </div>
                                                            <div v-else>
                                                                {{numFormat.formatNumber(props.item.salaryEnd)}}
                                                            </div>
                                                        </v-flex>
                                                    </v-layout>
                                                    <v-layout row>
                                                        <v-flex xs4>
                                                            <div class="caption grey--text text--darken-1">Employee Share</div>
                                                            <div>{{numFormat.formatNumber(props.item.employeeShare*100)}} %</div>
                                                        </v-flex>
                                                        <v-flex xs4>
                                                            <div class="caption grey--text text--darken-1">Employer Share</div>
                                                            <div>{{numFormat.formatNumber(props.item.employerShare*100)}} %</div>
                                                        </v-flex>
                                                        <v-flex xs4>
                                                            <div class="caption grey--text text--darken-1">Maximum Amt</div>
                                                            <div> {{numFormat.formatNumber(props.item.maxAmount)}}</div>
                                                        </v-flex>
                                                    </v-layout>
                                                </v-flex>
                                            </v-layout>
                                        </v-card>
                                    </td>
                                </tr>

                                <!-- desktop view -->
                                <tr v-else>
                                    <td>{{ props.item.effectiveDate | moment('MMM DD, YYYY')}}</td>
                                    <td>
                                        <div class="text-xs-right">
                                            {{numFormat.formatNumber(props.item.salaryStart)}}
                                        </div>
                                    </td>
                                    <td>
                                        <div v-if="props.item.salaryEnd>1500" class="text-xs-right">
                                            Above {{numFormat.formatNumber(props.item.salaryStart)}}
                                        </div>
                                        <div v-else class="text-xs-right">
                                            {{numFormat.formatNumber(props.item.salaryEnd)}}
                                        </div>
                                    </td>
                                    <td>
                                        <div class="text-xs-right">
                                            {{numFormat.formatNumber(props.item.employeeShare*100)}} %
                                        </div>
                                    </td>
                                    <td>
                                        <div class="text-xs-right">
                                            {{numFormat.formatNumber(props.item.employerShare*100)}} %
                                        </div>
                                    </td>
                                    <td>
                                        <div class="text-xs-right">
                                            {{numFormat.formatNumber(props.item.maxAmount)}}
                                        </div>
                                    </td>
                                </tr>
                            </template>
                        </v-data-table> 
                    </v-card>
                </v-expansion-panel-content>

                <!-- Philhealth Table -->
                <v-expansion-panel-content>
                    <template v-slot:header>
                        <span class="font-weight-bold  primary--text">Philhealth Table</span>
                        <v-spacer></v-spacer>
                    </template>
                    <v-card class="elavation-1 transparent">
                        <v-data-table
                            :headers="isMobile ? [] : header_Philhealth"
                            :items="ref_tables.philHealthTable"
                            :loading="loading"
                            :rows-per-page-items="rowsPerPageItems"
                            :pagination.sync="paginationSyncPhilhealth"
                            :hide-headers="isMobile"
                        >
                            <template v-slot:items="props">

                                <!-- mobile view -->
                                <tr v-if="isMobile">
                                    <td :colspan="header_Philhealth.length" class="pa-1">
                                        <v-card class="elevation-1">
                                            <v-layout row wrap align-center class="section-layout">
                                                <v-flex xs12 class="text-xs-left mt-5 mb-2">
                                                    <v-layout row>
                                                        <v-flex xs4>
                                                            <div class="caption grey--text text--darken-1">Effective Date</div>
                                                            <div>{{ props.item.effectiveDate | moment('MMM DD, YYYY')}}</div>
                                                        </v-flex>
                                                        <v-flex xs4>
                                                            <div class="caption grey--text text--darken-1">Salary From</div>
                                                            <div>{{numFormat.formatNumber(props.item.salaryStart)}}</div>
                                                        </v-flex>
                                                        <v-flex xs4>
                                                            <div class="caption grey--text text--darken-1">Salary To</div>
                                                            <div v-if="props.item.salaryEnd>100000">
                                                                Above {{numFormat.formatNumber(props.item.salaryStart)}}
                                                            </div>
                                                            <div v-else>
                                                                {{numFormat.formatNumber(props.item.salaryEnd)}}
                                                            </div>
                                                        </v-flex>
                                                    </v-layout>
                                                    <v-layout row>
                                                        <v-flex xs4>
                                                            <div class="caption grey--text text--darken-1">Premium Rate</div>
                                                            <div v-if="props.item.premiumRate">
                                                                {{numFormat.formatNumber(props.item.premiumRate*100)}} %
                                                            </div>
                                                            <div v-else>
                                                                -
                                                            </div>
                                                        </v-flex>
                                                        <v-flex xs4>
                                                            <div class="caption grey--text text--darken-1">Minimum Amount</div>
                                                            <div v-if="props.item.floorAmt">
                                                                {{numFormat.formatNumber(props.item.floorAmt)}}
                                                            </div>
                                                            <div v-else>
                                                                -
                                                            </div>
                                                        </v-flex>
                                                        <v-flex xs4>
                                                            <div class="caption grey--text text--darken-1">Maximum Amount</div>
                                                            <div v-if="props.item.ceilingAmt">
                                                                {{numFormat.formatNumber(props.item.ceilingAmt)}}
                                                            </div>
                                                            <div v-else>
                                                                -
                                                            </div>
                                                        </v-flex>
                                                    </v-layout>
                                                </v-flex>
                                            </v-layout>
                                        </v-card>
                                    </td>
                                </tr>

                                <!-- desktop view -->
                                <tr v-else>
                                    <td>{{ props.item.effectiveDate | moment('MMM DD, YYYY')}}</td>
                                    <td>
                                        <div class="text-xs-right">
                                            {{numFormat.formatNumber(props.item.salaryStart)}}
                                        </div>
                                    </td>
                                    <td>
                                        <div v-if="props.item.salaryEnd>100000" class="text-xs-right">
                                            Above {{numFormat.formatNumber(props.item.salaryStart)}}
                                        </div>
                                        <div v-else class="text-xs-right">
                                            {{numFormat.formatNumber(props.item.salaryEnd)}}
                                        </div>
                                    </td>
                                    <td>
                                        <div v-if="props.item.premiumRate" class="text-xs-right">
                                            {{numFormat.formatNumber(props.item.premiumRate*100)}} %
                                        </div>
                                        <div v-else class="text-xs-right">
                                            -
                                        </div>
                                    </td>
                                    <td>
                                        <div v-if="props.item.floorAmt" class="text-xs-right">
                                            {{numFormat.formatNumber(props.item.floorAmt)}}
                                        </div>
                                        <div v-else class="text-xs-right">
                                            -
                                        </div>
                                    </td>
                                    <td>
                                        <div v-if="props.item.ceilingAmt" class="text-xs-right">
                                            {{numFormat.formatNumber(props.item.ceilingAmt)}}
                                        </div>
                                        <div v-else class="text-xs-right">
                                            -
                                        </div>
                                    </td>
                                </tr>
                            </template>
                        </v-data-table> 
                    </v-card>
                </v-expansion-panel-content>

                <!-- Overtime Rates Table -->
                <v-expansion-panel-content>
                    <template v-slot:header>
                        <span class="font-weight-bold  primary--text">Overtime Rates Table</span>
                        <v-spacer></v-spacer>
                    </template>
                    <v-card class="elavation-1 transparent">
                        <v-data-table
                            :headers="isMobile ? [] : header_Overtime"
                            :items="ref_tables.overtimeRatesTable"
                            :loading="loading"
                            :rows-per-page-items="rowsPerPageItems"
                            :pagination.sync="paginationSyncOT"
                            :hide-headers="isMobile"
                        >
                            <template v-slot:items="props">

                                <!-- mobile view -->
                                <tr v-if="isMobile">
                                    <td :colspan="header_Philhealth.length" class="pa-1">
                                        <v-card class="elevation-1">
                                            <v-layout row wrap align-center class="section-layout">
                                                <v-flex xs12 class="text-xs-left mt-5 mb-2">
                                                    <v-layout row>
                                                        <v-flex xs4>
                                                            <div class="caption grey--text text--darken-1">Description</div>
                                                            <div>{{ props.item.description }}</div>
                                                        </v-flex>
                                                        <v-flex xs4>
                                                            <div class="caption grey--text text--darken-1">Working Hours</div>
                                                            <div>{{ props.item.workingHours }}</div>
                                                        </v-flex>
                                                        <v-flex xs4>
                                                            <div class="caption grey--text text--darken-1">Day Type</div>
                                                            <div>{{ props.item.dayType }}</div>
                                                        </v-flex>
                                                    </v-layout>
                                                    <v-layout row>
                                                        <v-flex xs4>
                                                            <div class="caption grey--text text--darken-1">Holiday Type</div>
                                                            <div>{{ props.item.holidayType }}</div>
                                                        </v-flex>
                                                        <v-flex xs4>
                                                            <div class="caption grey--text text--darken-1">Base+Premium</div>
                                                            <div>{{numFormat.formatNumber(props.item.rate)}} %</div>
                                                        </v-flex>
                                                        <v-flex xs4>
                                                            <div class="caption grey--text text--darken-1">Premium Only Rate</div>
                                                            <div>{{numFormat.formatNumber(props.item.premiumOnlyRate)}} %</div>
                                                        </v-flex>
                                                    </v-layout>
                                                </v-flex>
                                            </v-layout>
                                        </v-card>
                                    </td>
                                </tr>

                                <!-- desktop view -->
                                <tr v-else>
                                    <td>{{ props.item.description }}</td>
                                    <td>{{ props.item.workingHours }}</td>
                                    <td>{{ props.item.dayType }}</td>
                                    <td>{{ props.item.holidayType }}</td>
                                    <td>
                                        <div class="text-xs-right">
                                            {{numFormat.formatNumber(props.item.rate)}} %
                                        </div>
                                    </td>
                                    <td>
                                        <div class="text-xs-right">
                                            {{numFormat.formatNumber(props.item.premiumOnlyRate)}} %
                                        </div>
                                    </td>
                                </tr>
                            </template>
                        </v-data-table> 
                    </v-card>
                </v-expansion-panel-content>

                <!-- Minimum Wage Table -->
                <v-expansion-panel-content>
                    <template v-slot:header>
                        <span class="font-weight-bold  primary--text">Minimum Wage Table</span>
                        <v-spacer></v-spacer>
                    </template>
                    <v-card class="elavation-1 transparent">
                        <v-data-table
                            :headers="isMobile ? [] : header_MinimumWage"
                            :items="ref_tables.minimumWage"
                            :loading="loading"
                             :rows-per-page-items="rowsPerPageItems"
                            :pagination.sync="paginationSyncMW"
                            :hide-headers="isMobile"
                        >
                            <template v-slot:items="props">

                                 <!-- mobile view -->
                                <tr v-if="isMobile">
                                    <td :colspan="header_MinimumWage.length" class="pa-1">
                                        <v-card class="elevation-1">
                                            <v-layout row wrap align-center class="section-layout">
                                                <v-flex xs12 class="text-xs-left mt-5 mb-2">
                                                    <v-layout row>
                                                        <v-flex xs4>
                                                            <div class="caption grey--text text--darken-1">Year</div>
                                                            <div>{{ props.item.year }}</div>
                                                        </v-flex>
                                                        <v-flex xs4>
                                                            <div class="caption grey--text text--darken-1">Region</div>
                                                            <div>{{ props.item.regionCode }}</div>
                                                        </v-flex>
                                                        <v-flex xs4>
                                                            <div class="caption grey--text text--darken-1">Sector</div>
                                                            <div>{{ props.item.sector }}</div>
                                                        </v-flex>
                                                    </v-layout>
                                                    <v-layout row>
                                                        <v-flex xs4>
                                                            <div class="caption grey--text text--darken-1">Salary From</div>
                                                            <div>{{numFormat.formatNumber(props.item.fromAmount)}}</div>
                                                        </v-flex>
                                                        <v-flex xs4>
                                                            <div class="caption grey--text text--darken-1">Salary To</div>
                                                            <div>{{numFormat.formatNumber(props.item.toAmount)}}</div>
                                                        </v-flex>
                                                    </v-layout>
                                                </v-flex>
                                            </v-layout>
                                        </v-card>
                                    </td>
                                </tr>

                                <!-- desktop view -->
                                <tr v-else>
                                    <td>{{ props.item.year }}</td>
                                    <td>{{ props.item.regionCode }}</td>
                                    <td>{{ props.item.sector }}</td>
                                    <td>
                                        <div class="text-xs-right">
                                            {{numFormat.formatNumber(props.item.fromAmount)}}
                                        </div>
                                    </td>
                                    <td>
                                        <div class="text-xs-right">
                                            {{numFormat.formatNumber(props.item.toAmount)}}
                                        </div>
                                    </td>
                                </tr>
                            </template>
                        </v-data-table> 
                    </v-card>
                </v-expansion-panel-content>
            </v-expansion-panel>
        </v-flex>
    </v-layout> 
</template>

<script>

import payrollApi from '@/api/payroll'
import numFormat from '@/common/num_format'
import userPrefs from '@/helpers/user-prefs'
import rowsPerPageItems from '@/constants/rows-per-page'

export default {     
    name: 'ReferenceTables',
    metaInfo: {
        title: 'Reference Tables',
        meta: [
            { charset: 'utf-8' },
            { name: 'description', content: 'Reference Tables' },
            { name: 'viewport', content: 'width=device-width, initial-scale=1' }
            ]
    },
    components: {
        'help-link': () => import('@/components/Common/HelpLink'),
    },   
    data () {
        return {
            numFormat,
            rowsPerPageItems,
            error: false,
            errorMessage: '',
            loading: false,
            panel: [false],
            ref_tables: [],
            paginationSyncTax: {rowsPerPage: userPrefs.getRowsPerPage(`${this.$route.name}-Tax`)},
            paginationSyncSSS: {rowsPerPage: userPrefs.getRowsPerPage(`${this.$route.name}-SSS`)},
            paginationSyncPagibig: {rowsPerPage: userPrefs.getRowsPerPage(`${this.$route.name}-Pagibig`)},
            paginationSyncPhilhealth: {rowsPerPage: userPrefs.getRowsPerPage(`${this.$route.name}-Philhealth`)},
            paginationSyncOT: {rowsPerPage: userPrefs.getRowsPerPage(`${this.$route.name}-OT`)},
            paginationSyncMW: {rowsPerPage: userPrefs.getRowsPerPage(`${this.$route.name}-MW`)},
            header_IcomeTaxTable: [
                {text:'Type', align: 'left',value: '', width: '20%', sortable:false},
                {text:'Effective Date', align: 'left',value: '', width: '20%', sortable:false},
                {text:'Lower Limit', align: 'right',value: '', width: '15%', sortable:false},
                {text:'Upper Limit', align: 'right',value: '',  width: '15%', sortable:false},
                {text:'Tax on Lower Limit', align: 'right',value: '',  width: '15%', sortable:false},
                {text:'Tax on Excess over Lower Limit', align:'right',value: '',  width: '15%', sortable:false},
            ],
            header_SSS: [
                {text:'Effective Date', align: 'left',value: '', width: '10%', sortable:false},
                {text:'Salary From', align: 'right',value: '', width: '10%', sortable:false},
                {text:'Salary To', align: 'right',value: '',  width: '10%', sortable:false},
                {text:'RSS_ER', align: 'right',value: '',  width: '10%', sortable:false},
                {text:'RSS_EE', align:'right',value: '',  width: '10%', sortable:false},
                {text:'EC_ER', align:'right',value: '',  width: '10%', sortable:false},
                {text:'EC_EE', align:'right',value: '',  width: '10%', sortable:false},
                {text:'WISP_ER', align:'right',value: '',  width: '10%', sortable:false},
                {text:'WISP_EE', align:'right',value: '',  width: '10%', sortable:false},
            ],
            header_Pagibig: [
                {text:'Effective Date', align: 'left',value: '', width: '15%', sortable:false},
                {text:'Salary From', align: 'right',value: '', width: '15%', sortable:false},
                {text:'Salary To', align: 'right',value: '',  width: '15%', sortable:false},
                {text:'Employee Share', align: 'right',value: '',  width: '15%', sortable:false},
                {text:'Employer Share', align:'right',value: '',  width: '15%', sortable:false},
                {text:'Maximum Amt', align:'right',value: '',  width: '15%', sortable:false},
            ],
            header_Philhealth: [
                {text:'Effective Date', align: 'left',value: '', width: '20%', sortable:false},
                {text:'Salary From', align: 'right',value: '', width: '20%', sortable:false},
                {text:'Salary To', align: 'right',value: '',  width: '20%', sortable:false},
                {text:'Premium Rate', align: 'right',value: '',  width: '20%', sortable:false},
                {text:'Minimum Amount', align:'right',value: '',  width: '20%', sortable:false},
                {text:'Maximum Amount', align:'right',value: '',  width: '20%', sortable:false},
            ],
            header_Overtime: [
                {text:'Description', align: 'left',value: '', width: '40%', sortable:false},
                {text:'Working Hours', align: 'left',value: '', width: '10%', sortable:false},
                {text:'Day Type', align: 'left',value: '', width: '10%', sortable:false},
                {text:'Holiday Type', align: 'left',value: '', width: '30%', sortable:false},
                {text:'Base+Premium Rate', align:'right',value: '',  width: '10%', sortable:false},
                {text:'Premium Only Rate', align:'right',value: '',  width: '10%', sortable:false},
            ],
            header_MinimumWage: [
                {text:'Year', align: 'left',value: '', width: '10%', sortable:false},
                {text:'Region', align: 'left',value: '', width: '20%', sortable:false},
                {text:'Sector', align: 'left',value: '', width: '30%', sortable:false},
                {text:'Salary From', align: 'right',value: '', width: '20%', sortable:false},
                {text:'Salary To', align:'right',value: '',  width: '20%', sortable:false},
            ],
        }
    },
    methods: {
        async getData() {
            try {
                this.loading = true
                const response = await payrollApi.getReferenceTables()
                if (response && response.status==200) {
                    this.ref_tables = response.data
                }
                this.loading = false
            }catch(error){
                this.error = true
                this.errorMessage = error
            }
        }
    },
    async created() {
        //update header titles
        this.$root.$emit('setHeaderTitles', {
            display: true,
            headerTitle: '',
            headerPageTitle: 'Payroll Reference Tables'
        })

        this.getData()
    },
    watch: {
        'paginationSyncTax.rowsPerPage'(newVal) {
            userPrefs.updateRowsPerPage(`${this.$route.name}-Tax`, newVal);
        },
        'paginationSyncSSS.rowsPerPage'(newVal) {
            userPrefs.updateRowsPerPage(`${this.$route.name}-SSS`, newVal);
        },
        'paginationSyncPagibig.rowsPerPage'(newVal) {
            userPrefs.updateRowsPerPage(`${this.$route.name}-Pagibig`, newVal);
        },
        'paginationSyncPhilhealth.rowsPerPage'(newVal) {
            userPrefs.updateRowsPerPage(`${this.$route.name}-Philhealth`, newVal);
        },
        'paginationSyncOT.rowsPerPage'(newVal) {
            userPrefs.updateRowsPerPage(`${this.$route.name}-OT`, newVal);
        },
        'paginationSyncMW.rowsPerPage'(newVal) {
            userPrefs.updateRowsPerPage(`${this.$route.name}-MW.`, newVal);
        }
    },
    computed: {
        isMobile() {
            return window.innerWidth < 600
        },
    }
}
</script>
<style scoped>
.section-layout {
    padding:0px 23px 0px 23px;
}
</style>